/**
 * ルート名定義
 * 来場者アプリのナビゲーションルート名を管理します
 */

/** 来場者フロールート */
const VISITOR_FLOW_ROUTE = "VisitorFlow";

/** ルートグループ（最上位） */
export const ROOT_ROUTES = Object.freeze({
  VISITOR_FLOW: VISITOR_FLOW_ROUTE,
});

/** 来場者ルートグループ */
export const VISITOR_ROUTES = Object.freeze({
  ENTRY: "VisitorEntry",
  LOGIN: "VisitorLogin",
  REGISTER: "VisitorRegister",
  HOME: "VisitorHome",
  NOTICES: "VisitorNotices",
  EVENTS: "VisitorEvents",
  SCAN: "VisitorScan",
  REWARDS: "VisitorRewards",
  REDEEM_QR: "VisitorRedeemQr",
  REDEMPTIONS: "VisitorRedemptions",
  SURVEYS: "VisitorSurveys",
  STALL_RATING: "VisitorStallRating",
  RANKING: "VisitorRanking",
  GROUP: "VisitorGroup",
  CAMPUS_MAP: "VisitorCampusMap",
});
